<div class="consultation-container">
  <!-- Search Section -->
  <div class="search-card mb-2">
    <div class="row">
      <div class="col col-md-3">
        <app-benef-info [beneficiaireAutOselect]="beneficiaireAutOselect">
          <app-search-form (sendUserInfo)="onSetUserInfo($event)"></app-search-form>
        </app-benef-info>
      </div>
      <div class="col col-md-9">
        <div class="consultation-form-card">
          <div class="card-body">

            <!-- ── Skeleton (avant recherche) ── -->
            <ng-container *ngIf="!itemBeneficiare?.id">
              <div class="row g-2">
                <div class="col-12" *ngFor="let s of [1,2,3,4,5,6]">
                  <div class="row align-items-center gx-3">
                    <div class="col-4">
                      <span class="skel-cell" style="width:80%; height:12px"></span>
                    </div>
                    <div class="col-7">
                      <span class="skel-cell" style="width:100%; height:34px; border-radius:6px"></span>
                    </div>
                  </div>
                </div>
              </div>
              <div class="row mt-2">
                <div class="col-12">
                  <div class="submit-section">
                    <span class="skel-cell" style="width:100%; height:44px; border-radius:8px; display:block"></span>
                  </div>
                </div>
              </div>
            </ng-container>

            <!-- ── Formulaire réel ── -->
            <ng-container *ngIf="itemBeneficiare?.id">
              <div class="row g-2">

                <!-- Acte médical -->
                <div class="col-12">
                  <div class="row align-items-center gx-3">
                    <label for="acte" class="col-4 col-form-label form-label required">
                      <i class="fas fa-procedures me-1"></i>
                      Acte médical
                    </label>
                    <div class="col-7">
                      <ng-select id="acte" [items]="itemsActe" bindLabel="libelle" bindValue="id"
                        [(ngModel)]="itemConsultation.acte_id" [searchable]="true" [clearable]="true"
                        placeholder="Sélectionnez un acte médical" (change)="onSelectActe()" class="custom-select">
                      </ng-select>
                    </div>
                  </div>
                </div>

                <!-- Médecin traitant -->
                <div class="col-12">
                  <div class="row align-items-center gx-3">
                    <label for="medecin" class="col-4 col-form-label form-label required">
                      <i class="fas fa-user-md me-1"></i>
                      Médecin traitant
                    </label>
                    <div class="col-7">
                      <ng-select id="medecin" (change)="onSelectMedecin()" [items]="itemsPratitien" bindLabel="full_name"
                        bindValue="id" [(ngModel)]="itemConsultation.praticien_id" placeholder="Sélectionnez le praticien"
                        class="custom-select">
                      </ng-select>
                    </div>
                  </div>
                </div>

                <!-- Raison de consultation -->
                <div class="col-12">
                  <div class="row align-items-center gx-3">
                    <label for="raison" class="col-4 col-form-label form-label">
                      <i class="fas fa-clipboard-list me-1"></i>
                      Raison de consultation
                    </label>
                    <div class="col-7">
                      <ng-select id="raison" [items]="itemsRaisonConsultation" bindLabel="libelle" bindValue="id"
                        [(ngModel)]="itemConsultation.raison_consultation_id"
                        placeholder="Sélectionnez la raison de consultation" class="custom-select">
                      </ng-select>
                    </div>
                  </div>
                </div>

                <!-- Montants -->
                <div class="col-12">
                  <div class="financial-section">
                    <!-- Loader tarif -->
                    <div *ngIf="isLoadingTarif" class="tarif-loader">
                      <span class="spinner-border spinner-border-sm me-2" role="status"></span>
                      Calcul du tarif en cours…
                    </div>
                    <div *ngIf="!isLoadingTarif" class="row g-2">
                      <div class="col-4">
                        <div class="amount-card total-amount">
                          <div class="amount-label"><i class="fas fa-coins me-1"></i>Total</div>
                          <div class="amount-value">{{itemConsultation.montant | IntegerFormatPipe}}</div>
                        </div>
                      </div>
                      <div class="col-4">
                        <div class="amount-card patient-amount" [class.has-depassement]="itemConsultation.depassement > 0">
                          <div class="amount-label"><i class="fas fa-user me-1"></i>Part patient</div>
                          <div *ngIf="itemConsultation.depassement > 0" class="amount-old">{{(itemConsultation.part_patient - itemConsultation.depassement) | IntegerFormatPipe}}</div>
                          <div class="amount-value" [class.depassement-value]="itemConsultation.depassement > 0">{{itemConsultation.part_patient | IntegerFormatPipe}}</div>
                        </div>
                      </div>
                      <div class="col-4">
                        <div class="amount-card insurance-amount" [class.has-depassement]="itemConsultation.depassement > 0">
                          <div class="amount-label"><i class="fas fa-shield-alt me-1"></i>Part assurance</div>
                          <div *ngIf="itemConsultation.depassement > 0" class="amount-old">{{(itemConsultation.part_assurance + itemConsultation.depassement) | IntegerFormatPipe}}</div>
                          <div class="amount-value" [class.depassement-value]="itemConsultation.depassement > 0">{{itemConsultation.part_assurance | IntegerFormatPipe}}</div>
                        </div>
                      </div>
                    </div>
                    <!-- Alerte dépassement -->
                    <div *ngIf="!isLoadingTarif && itemConsultation.message_depassement" class="depassement-alert mt-2">
                      <i class="fas fa-exclamation-triangle me-1"></i>
                      {{itemConsultation.message_depassement}}
                    </div>
                  </div>
                </div>

                <!-- Messages / Coverage info -->
                <div *ngIf="itemConsultation?.taux_applicable || itemConsultation?.message_explicatif || itemConsultation?.tarif_en_vigeur" class="col-12">
                  <div class="coverage-info">
                    <div class="info-card">
                      <div class="info-header"><i class="fas fa-info-circle me-1"></i>Informations de prise en charge</div>
                      <div class="info-tags">
                        <span *ngIf="itemConsultation.taux_applicable" class="info-tag tag-blue">Taux: {{itemConsultation.taux_applicable}}%</span>
                        <span *ngIf="itemConsultation.message_explicatif" class="info-tag tag-green">{{itemConsultation.message_explicatif}}</span>
                        <span *ngIf="itemConsultation.tarif_en_vigeur" class="info-tag tag-gray">{{itemConsultation.tarif_en_vigeur}}</span>
                      </div>
                    </div>
                  </div>
                </div>

                <!-- Document joint -->
                <div class="col-12">
                  <div class="row align-items-center gx-3">
                    <label for="fichier1" class="col-4 col-form-label form-label">
                      <i class="fas fa-paperclip me-1"></i>
                      Document joint
                    </label>
                    <div class="col-7">
                      <input type="file" class="form-control" id="fichier1" name="fichier1" (change)="uploadFile($event)"
                        accept=".pdf,.jpg,.jpeg,.png">
                      <small class="text-muted">
                        <i class="fas fa-info-circle me-1"></i>
                        Formats acceptés: PDF, JPG, PNG (max 5MB)
                      </small>
                    </div>
                  </div>
                </div>

              </div>

              <!-- Submit Section -->
              <div class="row mt-2">
                <div class="col-12">
                  <div class="submit-section">
                    <button style="width: 100%;" (click)="confirmSaveItem()" [disabled]="isSaving" class="btn btn-success btn-lg submit-btn">
                      <span *ngIf="isSaving" class="spinner-border spinner-border-sm me-2" role="status"></span>
                      <i *ngIf="!isSaving" class="fas fa-paper-plane me-2"></i>
                      <span *ngIf="!isSaving && !isConsultationSuccess">Soumettre la consultation</span>
                      <span *ngIf="!isSaving && isConsultationSuccess">
                        <i class="fas fa-check me-2"></i>Consultation soumise
                      </span>
                      <span *ngIf="isSaving">Enregistrement…</span>
                    </button>

                    <div *ngIf="!itemConsultation.acte_id" class="mt-1 text-muted small text-center">
                      <i class="fas fa-exclamation-triangle me-1"></i>
                      Veuillez sélectionner un acte médical et un médecin pour continuer
                    </div>
                    <div *ngIf="itemConsultation.acte_id && !itemConsultation.praticien_id"
                      class="mt-1 text-muted small text-center">
                      <i class="fas fa-exclamation-triangle me-1"></i>
                      Veuillez sélectionner un médecin pour continuer
                    </div>
                    <div
                      *ngIf="itemConsultation.acte_id && itemConsultation.praticien_id && !itemConsultation.raison_consultation_id"
                      class="mt-1 text-muted small text-center">
                      <i class="fas fa-exclamation-triangle me-1"></i>
                      Veuillez sélectionner une raison pour continuer
                    </div>
                  </div>
                </div>
              </div>
            </ng-container>

          </div>
        </div>
      </div>
    </div>

  </div>